package co.maytes.standupbot.dashboard.features.standupdetail

import co.maytes.standupbot.dashboard.components.motion.ViewPhase
import co.maytes.standupbot.dashboard.features.standups.TeamTab
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.standup.StandupDto
import co.maytes.standupbot.shared.dto.standup.UpdateStandupRequestDto
import co.maytes.standupbot.shared.dto.standuprun.StandupRunSummaryDto
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState
import kotlinx.datetime.LocalDate

object StandupDetailContract {
    sealed interface Status {
        data object Loading : Status
        data object Ready : Status
        data class Error(val error: ApiError) : Status
    }

    data class State(
        val workspaceId: String = "",
        val standupId: String = "",
        val status: Status = Status.Loading,
        val standup: StandupDto? = null,
        val activeTab: TeamTab = TeamTab.Overview,
        val triggerInFlight: Boolean = false,
        val saveInFlight: Boolean = false,
        val runForDateOpen: Boolean = false,
        val deleteOpen: Boolean = false,
        val recentRuns: List<StandupRunSummaryDto> = emptyList(),
    ) : MVIState {
        val phase: ViewPhase
            get() = when (status) {
                Status.Loading -> ViewPhase.Loading
                is Status.Error -> ViewPhase.Error
                Status.Ready -> if (standup == null) ViewPhase.Loading else ViewPhase.Ready
            }
    }

    sealed interface Intent : MVIIntent {
        data class Load(val workspaceId: String, val standupId: String) : Intent
        data object Retry : Intent
        data object Back : Intent
        data class SelectTab(val tab: TeamTab) : Intent
        data class Trigger(val date: LocalDate? = null) : Intent
        data object OpenRunForDate : Intent
        data object CloseRunForDate : Intent
        data object OpenDelete : Intent
        data object CloseDelete : Intent
        data object ConfirmDelete : Intent
        data class Save(val patch: UpdateStandupRequestDto) : Intent
    }

    sealed interface Action : MVIAction {
        data class Navigate(val path: String) : Action
        data class Toast(val message: String, val error: Boolean = false) : Action
    }
}
